import {
  ARCHIVED_CHAT_LIST_QUERY_KEY,
  CHAT_HISTORY_QUERY_KEY,
  CHAT_LIST_QUERY_KEY,
  CHAT_QUERY_KEY,
} from "@frontend-shared/constants";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { chatApi } from "@/api/services";

interface IUnarchiveChatParams {
  uuid: string;
}

// NOTE: Backend uses toggle mechanism - same endpoint toggles archive state
const unarchiveChat = async ({ uuid }: IUnarchiveChatParams): Promise<void> => {
  await chatApi.archiveChat(uuid);
};

export const useUnarchiveChat = (onSuccess?: () => void) => {
  const { t } = useTranslation("sidebar");
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: unarchiveChat,
    onSuccess: () => {
      onSuccess?.();
      toast.success(t("chat_list.moved_out_of_archive"));
      queryClient.invalidateQueries({
        queryKey: [CHAT_QUERY_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [CHAT_HISTORY_QUERY_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [CHAT_LIST_QUERY_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [ARCHIVED_CHAT_LIST_QUERY_KEY],
      });
    },
  });
};
